import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './styles.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ArrowUp } from 'components/icons';
import { ROUTE_MAP } from 'consts/url';
import { useTranslation } from 'react-i18next';

const keyArr = Object.keys(ROUTE_MAP).map((key) => ROUTE_MAP[key].id);

const MenuTop = () => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMenuMobile, setOpenMenuMobile] = useState(true);
  // const { scenes } = useSelector((state) => state);
  const history = useHistory();

  const { pathname } = useLocation();

  const newPathName = pathname.split('/')[1] || '';

  // const [initialScene, mainScene] = useMemo(() => {
  //   return [
  //     sceneDataUtils.findIndoorInitialScene(scenes),
  //     sceneDataUtils.findMainScene(scenes),
  //   ];
  // }, [scenes]);

  const menuOverwride = useMemo(
    () => [
      {
        id: ROUTE_MAP.overview.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.overview.id}`);
        },
        name: t(ROUTE_MAP.overview.label),
      },
      {
        id: ROUTE_MAP.neighborhood.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.neighborhood.id}`);
        },
        name: t(ROUTE_MAP.neighborhood.label),
      },

      {
        id: ROUTE_MAP.masterplan.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.masterplan.id}`);
        },
        name: t(ROUTE_MAP.masterplan.label),
      },
      {
        id: ROUTE_MAP['floor-plan'].id,
        onClick: () => {
          history.push(`/${ROUTE_MAP['floor-plan'].id}`);
        },
        name: t(ROUTE_MAP['floor-plan'].label),
      },
      {
        id: ROUTE_MAP.interior.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.interior.id}/1pn-plus/tong-quan`);
        },
        name: t(ROUTE_MAP.interior.label),
      },
      {
        id: ROUTE_MAP.amenityLayout.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.amenityLayout.id}`);
        },
        name: t(ROUTE_MAP.amenityLayout.label),
      },
      {
        id: ROUTE_MAP.library.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.library.id}`);
        },
        name: t(ROUTE_MAP.library.label),
      },
    ],
    [history, t]
  );

  const mapMenuToPath = useMemo(() => {
    return menuOverwride;
  }, [menuOverwride]);

  const toggleMenuArrow = () => {
    if (isCollapsed) return;
    setOpenMenuMobile((prev) => !prev);
  };

  const toggleHamburger = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      if (next) {
        setOpenMenuMobile(false);
      } else {
        setOpenMenuMobile(true);
      }
      return next;
    });
  };

  const containerClassNames = [
    'nav-desktop-container',
    openMenuMobile ? 'open-mobile' : '',
    isCollapsed ? 'collapsed' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className={containerClassNames}>
        <div className="menu-logo">
          <button
            className={`menu-hamburger ${!isCollapsed ? 'open' : ''}`}
            aria-label={isCollapsed ? 'Open menu' : 'Close menu'}
            onClick={toggleHamburger}
          >
            <span />
            <span />
            <span />
          </button>

          <div className="logo-container">
            <img src={'/assets/images/logo/aurora.webp'} alt="Logo" />
          </div>
          <button
            className="menu-arrow"
            onClick={toggleMenuArrow}
            disabled={isCollapsed}
          >
            <ArrowUp />
          </button>
        </div>

        <div className="menu-content">
          {mapMenuToPath.map((item) => {
            let isActive = false;

            if (keyArr.includes(newPathName)) {
              isActive = newPathName === item.id;
            } else {
              isActive = item.id === 'tong-quan';
            }

            return (
              <button
                key={item.id}
                onClick={item.onClick}
                className={`menu-item ${isActive ? 'active' : ''}`}
              >
                <span className="menu-item-label">{item.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* <div className="nav-mobile-container">
        <div className="menu-logo">
          <img
            src={'/assets/images/logo/wincity-logo-mobile.webp'}
            alt="Logo"
          />
        </div>
        <button
          className="menu-trigger"
          onClick={() => setOpenMenuMobile(!openMenuMobile)}
        >
          <span className="btn-label">{openMenuMobile ? 'CLOSE' : 'MENU'}</span>
          <IconHamburger isActive={openMenuMobile} />
        </button>

        <div className={`nav-mobile-menu ${openMenuMobile ? 'open' : ''}`}>
          {mapMenuToPath.map((item) => {
            let isActive = false;

            if (keyArr.includes(newPathName)) {
              isActive = newPathName === item.id;
            } else {
              isActive = item.id === 'tong-quan';
            }

            return (
              <button
                key={item.id}
                onClick={() => {
                  item.onClick();
                  setOpenMenuMobile(false);
                }}
                className={`menu-item ${isActive ? 'active' : ''}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
      </div> */}
    </>
  );
};

export default MenuTop;
